import { ILegalConsentOption } from './legal-consent-option.model';

export interface ILegalConsentOptions {
    communicationConsents: ILegalConsentOption[];
    processingConsents: ILegalConsentOption[];
}

export class LegalConsentOptions {
    communicationConsents: ILegalConsentOption[];
    processingConsents: ILegalConsentOption[];

    constructor(config?: ILegalConsentOptions) {
        this.communicationConsents = config?.communicationConsents ?? [];
        this.processingConsents = config?.processingConsents ?? [];
    }
}
